import React, { useState } from "react";
import { Button, Input } from "reactstrap";
import * as XLSX from "xlsx";

const ExcelPurchaseImport = ({ setInvoiceSheet }) => {
  const [fileName, setFileName] = useState("");

  const downloadSampleTemplate = () => {
    const templateData = [
      {
        item: "GLYCOMET-METFORMIN 10 Tablets HYDROCHLORIDE TABLETS IP 500 MG",
        quantity: 20,
        unitPrice: "",
        tax: "5",
        mrp: "2.04",
        hsn: "",
        batch: "56001550",
        productId: "SKU00332",
        stockQty: "",
        expiry: "2027-06-01",
        supplierId: "DIST00001",
        unit: "PC",
        category: "Medicine"
      }
    ];
    
    const ws = XLSX.utils.json_to_sheet(templateData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "PurchaseItems");
    XLSX.writeFile(wb, "Purchase_Template_Format.xlsx");
  };

  const handleExcelUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setFileName(file.name);
    const reader = new FileReader();

    reader.onload = (evt) => {
      try {
        const bstr = evt.target.result;
        const workbook = XLSX.read(bstr, { type: "binary" });
        
        const wsname = workbook.SheetNames[0];
        const ws = workbook.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws, { defval: "" });

        if (data.length === 0) {
          alert("The uploaded Excel file is empty.");
          return;
        }

        const getVal = (row, keys) => {
          for (let key of keys) {
            const foundKey = Object.keys(row).find(
              k => k.trim().toLowerCase() === key.toLowerCase()
            );
            if (foundKey !== undefined && row[foundKey] !== "") {
              return row[foundKey];
            }
          }
          return null;
        };

        // Map rows into your nested structure format: { RowX: { ... } }
        const formattedItems = data.map((row, index) => {
          const rowKey = `Row${index + 1}`;
          return {
            [rowKey]: {
              item: String(getVal(row, ["item", "item name", "description", "product", "name"]) || "").trim(),
              quantity: Number(getVal(row, ["quantity", "qty", "count"]) || 1),
              unitPrice: getVal(row, ["unitprice", "unit price", "rate", "price"]) ? String(getVal(row, ["unitprice", "unit price", "rate", "price"])) : null,
              tax: String(getVal(row, ["tax", "gst", "vat"]) || "5"),
              mrp: String(getVal(row, ["mrp", "retail price"]) || "0.00"),
              hsn: getVal(row, ["hsn", "hsn code", "sac"]) ? String(getVal(row, ["hsn", "hsn code", "sac"])) : null,
              batch: getVal(row, ["batch", "batch no", "batch number"]) ? String(getVal(row, ["batch", "batch no", "batch number"])) : null,
              productId: getVal(row, ["productid", "product id", "sku"]) ? String(getVal(row, ["productid", "product id", "sku"])) : null,
              stockQty: getVal(row, ["stockqty", "stock qty", "current stock"]) !== "" ? Number(getVal(row, ["stockqty", "stock qty", "current stock"])) : null,
              expiry: getVal(row, ["expiry", "expiry date", "exp"]) ? String(getVal(row, ["expiry", "expiry date", "exp"])) : null,
              location: {
                store: "",
                rack: "",
                shelf: "",
                bin: "",
                code: "",
                format: "rackShelfBin"
              },
              supplierId: String(getVal(row, ["supplierid", "supplier id", "vendor id"]) || "DIST00001")
            }
          };
        }).filter(item => Object.values(item)[0].item !== "");

        // Construct the full payload matching your MongoDB/State schema
        const fullPurchasePayload = {
          supplier: {
            supplierId: "DIST00001",
            address: "kavitha Medispark, K.No.89-10-34, Shop No.7, Ground Floor ,\nNehru Road Kammanahalli ,St. Thomas Town Post ,Bengaluru, Karnataka 560084\n",
            state: "Karnataka",
            contactNo: "8088740714",
            partyName: "Kavitha Medisparx",
            GSTIN: null
          },
          invoice: formattedItems,
          paymentDetails: {
            invoice_id: `TH${Date.now().toString().slice(-7)}`,
            invoice_date: new Date().toISOString(),
            payment_mode: "",
            amount_paid: "",
            GSTIN: "",
            registrationType: ""
          },
          additionalDetails: {
            notes: "",
            returnReason: "",
            credit: "",
            returnDate: ""
          },
          purchaseId: `PRCH${Math.floor(10000 + Math.random() * 90000)}`
        };

        setInvoiceSheet(fullPurchasePayload);
        alert(`Successfully imported ${formattedItems.length} items into the invoice schema!`);
      } catch (error) {
        console.error("Excel Parsing Error:", error);
        alert("Failed to parse the Excel file.");
      }
    };

    reader.readAsBinaryString(file);
  };

  return (
    <div className="p-4 border rounded bg-light mb-4 shadow-sm">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="font-weight-bold m-0">Bulk Excel Import & Template</h5>
        <Button color="primary" size="sm" onClick={downloadSampleTemplate}>
          📥 Download Excel Template Format
        </Button>
      </div>

      <div className="row g-3 align-items-center">
        <div className="col-md-8">
          <Input 
            type="file" 
            accept=".xlsx, .xls, .csv" 
            onChange={handleExcelUpload} 
          />
          {fileName && <small className="text-muted d-block mt-1">Loaded File: {fileName}</small>}
        </div>
        <div className="col-md-4">
          <small className="text-muted d-block">
            Upload your filled spreadsheet here to populate all item parameters automatically.
          </small>
        </div>
      </div>
    </div>
  );
};

export default ExcelPurchaseImport;